import { SearchComponentAction, SearchComponentState } from '../../../types';

export const initialState: SearchComponentState = {
  isLoading: false,
  showEvidenceModal: false,
  evidenceModalContent: '',
  evidenceModalData: '',
};

export const searchComponentReducer = (
  state: SearchComponentState,
  action: SearchComponentAction,
): SearchComponentState => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_SHOW_EVIDENCE_MODAL':
      return { ...state, showEvidenceModal: action.payload };
    case 'SET_EVIDENCE_MODAL_CONTENT':
      return { ...state, evidenceModalContent: action.payload };
    case 'SET_EVIDENCE_MODAL_DATA':
      return { ...state, evidenceModalData: action.payload };

    default:
      return state;
  }
};
